import { render } from "./News9.vue?vue&type=template&id=1c912a1a"
import script from "./News9.vue?vue&type=script&lang=js"
export * from "./News9.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__